//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { SystemCompany } from '../../graphql/entities';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';

const SYSTEM_COMPANY_COLUMN_OVERRIDES = {
  name: {
    name: 'Company Name',
  },
  dbName: {
    name: 'DB Name',
  },
  'smtpConfig.name': {
    name: 'SMTP Configuration',
  },
  enabled: {
    name: 'Enabled',
  },
  colourChoice: {
    name: 'Company Colour Choice',
  },
};

const SYSTEM_COMPANY_FIELD_NAMES = ['name', 'dbName', 'dbHost', 'smtpConfig.name', 'enabled'];

const { formUrl, type, title, workspace } = SystemCompany;

const SystemCompanyWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, SystemCompany, {
    columns: SYSTEM_COMPANY_FIELD_NAMES,
    columnOverrides: SYSTEM_COMPANY_COLUMN_OVERRIDES,
    initialSortColumn: 'name',
  });

  return (
    <Workspace
      entityType={type}
      title={title}
      formUrl={formUrl}
      defaultQuery={workspace}
      {...workspaceProps}
      {...props}
      entity={SystemCompany}
      includeGenericSearch={false}
    />
  );
};

export default SystemCompanyWorkspace;
